import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import httpclient from "../service/httpclient";

export const FEATURE_GATES = {
  LIVE_SERIES_PAGE: "live_series_page",
  LIVE_ANALOG_PAGE: "live_analog_page",
  MY_LIVE_PAGE: "my_live_page",
};

const FeatureGateContext = createContext({
  features: {},
  loading: true,
  refresh: () => {},
});

export function FeatureGateProvider({ children, refreshKey }) {
  const [features, setFeatures] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    setLoading(true);
    return httpclient
      .getFeatureGatesCurrent()
      .then((res) => {
        setFeatures(res?.features || {});
      })
      .catch(() => {
        setFeatures({});
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh, refreshKey]);

  const value = useMemo(
    () => ({
      features,
      loading,
      refresh,
    }),
    [features, loading, refresh]
  );

  return (
    <FeatureGateContext.Provider value={value}>
      {children}
    </FeatureGateContext.Provider>
  );
}

export function useFeatureGate(featureKey) {
  const { features } = useContext(FeatureGateContext);
  return !!features?.[featureKey];
}

export function FeatureGate({ feature, children, fallback = null }) {
  return useFeatureGate(feature) ? children : fallback;
}

export default FeatureGateContext;
